import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=51e6aa52"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"
import style0 from "./TicketDetails.vue?vue&type=style&index=0&id=51e6aa52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports